/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

export interface ParachuteControlActionArgs {
  enable: boolean;
  killMotors: boolean;
  deploy: boolean;
}

export interface ParachuteControlResultData {
}

export interface ParachuteControlActionStateData {
}

function createBaseParachuteControlActionArgs(): ParachuteControlActionArgs {
  return { enable: false, killMotors: false, deploy: false };
}

export const ParachuteControlActionArgs = {
  encode(message: ParachuteControlActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.enable === true) {
      writer.uint32(8).bool(message.enable);
    }
    if (message.killMotors === true) {
      writer.uint32(16).bool(message.killMotors);
    }
    if (message.deploy === true) {
      writer.uint32(24).bool(message.deploy);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ParachuteControlActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParachuteControlActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.enable = reader.bool();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.killMotors = reader.bool();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.deploy = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ParachuteControlActionArgs {
    return {
      enable: isSet(object.enable) ? globalThis.Boolean(object.enable) : false,
      killMotors: isSet(object.killMotors) ? globalThis.Boolean(object.killMotors) : false,
      deploy: isSet(object.deploy) ? globalThis.Boolean(object.deploy) : false,
    };
  },

  toJSON(message: ParachuteControlActionArgs): unknown {
    const obj: any = {};
    if (message.enable === true) {
      obj.enable = message.enable;
    }
    if (message.killMotors === true) {
      obj.killMotors = message.killMotors;
    }
    if (message.deploy === true) {
      obj.deploy = message.deploy;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ParachuteControlActionArgs>, I>>(base?: I): ParachuteControlActionArgs {
    return ParachuteControlActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ParachuteControlActionArgs>, I>>(object: I): ParachuteControlActionArgs {
    const message = createBaseParachuteControlActionArgs();
    message.enable = object.enable ?? false;
    message.killMotors = object.killMotors ?? false;
    message.deploy = object.deploy ?? false;
    return message;
  },
};

function createBaseParachuteControlResultData(): ParachuteControlResultData {
  return {};
}

export const ParachuteControlResultData = {
  encode(_: ParachuteControlResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ParachuteControlResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParachuteControlResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ParachuteControlResultData {
    return {};
  },

  toJSON(_: ParachuteControlResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ParachuteControlResultData>, I>>(base?: I): ParachuteControlResultData {
    return ParachuteControlResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ParachuteControlResultData>, I>>(_: I): ParachuteControlResultData {
    const message = createBaseParachuteControlResultData();
    return message;
  },
};

function createBaseParachuteControlActionStateData(): ParachuteControlActionStateData {
  return {};
}

export const ParachuteControlActionStateData = {
  encode(_: ParachuteControlActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ParachuteControlActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParachuteControlActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ParachuteControlActionStateData {
    return {};
  },

  toJSON(_: ParachuteControlActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ParachuteControlActionStateData>, I>>(base?: I): ParachuteControlActionStateData {
    return ParachuteControlActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ParachuteControlActionStateData>, I>>(_: I): ParachuteControlActionStateData {
    const message = createBaseParachuteControlActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
